module.exports = __webpack_public_path__ + "assets/images/project/banner_image_blueneutral_wphoto-desktop.jpg?v=0cb3fc19";